import { type ConversationStarter } from '@atlaskit/rovo-agent-components/ui/AgentConversationStarters';
import { type Agent } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

export const getConversationStarters = (agent: Agent): ConversationStarter[] | undefined =>
	agent?.user_defined_conversation_starters?.map((starter) => {
		return {
			message: starter,
			type: 'user-defined',
		};
	});
